import { BrowserRouter, Link, NavLink, Route, Routes } from 'react-router-dom';
import { SitzungsAnbieter, useSitzung } from './core/sitzung';
import { Symbol } from './core/symbole';
import { Laden, Leer } from './core/ui';
import { Anmelden, Einrichten, PasswortPflicht } from './core/seiten/Zugang';
import { Projekte } from './core/seiten/Projekte';
import { ProjektRahmen } from './core/seiten/ProjektRahmen';
import { Benutzer } from './core/seiten/Benutzer';
import { Konto } from './core/seiten/Konto';
import { WEB_MODULE } from './core/modul';

function Inhalt() {
  const { ich, laedt, einrichtungNoetig, abmelden } = useSitzung();
  if (laedt) return <Laden text="Beholder startet …" />;
  if (!ich) return einrichtungNoetig ? <Einrichten /> : <Anmelden />;
  if (ich.mussPasswortAendern) return <PasswortPflicht />;
  const global = WEB_MODULE.filter((m) => m.GlobalSeite && (m.globalSichtbar?.(ich) ?? true));

  return (
    <div className="huelle">
      <header className="kopfleiste">
        <Link to="/" className="marke-logo" aria-label="Beholder – Projekte">
          <img src="/beholder.svg" alt="" width={28} height={28} />
          <span>Beholder</span>
        </Link>
        <nav className="kopf-nav">
          <NavLink end to="/">
            Projekte
          </NavLink>
          {global.map((m) => (
            <NavLink key={m.id} to={`/modul/${m.id}`}>
              {m.globalName ?? m.name}
            </NavLink>
          ))}
          {ich.istAdmin && <NavLink to="/benutzer">Benutzer</NavLink>}
        </nav>
        <span className="abstand" />
        <NavLink to="/konto" className="kopf-ich" title="Mein Konto">
          {ich.anzeigename}
        </NavLink>
        <button type="button" className="knopf knopf-leise" onClick={() => void abmelden()} title="Abmelden" aria-label="Abmelden">
          {Symbol.abmelden}
        </button>
      </header>
      <Routes>
        <Route path="/" element={<Projekte />} />
        <Route path="/p/:projektId/*" element={<ProjektRahmen />} />
        <Route path="/konto" element={<Konto />} />
        {ich.istAdmin && <Route path="/benutzer" element={<Benutzer />} />}
        {global.map((m) => m.GlobalSeite && <Route key={m.id} path={`/modul/${m.id}/*`} element={<m.GlobalSeite ich={ich} />} />)}
        <Route path="*" element={<div className="seite"><Leer titel="Seite nicht gefunden" /></div>} />
      </Routes>
      {WEB_MODULE.map((m) => m.UeberallGlobal && <m.UeberallGlobal key={`global-${m.id}`} ich={ich} />)}
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <SitzungsAnbieter>
        <Inhalt />
      </SitzungsAnbieter>
    </BrowserRouter>
  );
}
